// import React from 'react';
// import { Container, Row, Col, Table, Card } from 'react-bootstrap';
// import './../../assets/css/CancellationPolicy.css';

// const CancellationPolicy = ({webSettings}) => {
//   console.log("test---",webSettings)
//   return (
//     <Container className="cancellation-policy-section">
//       <Card className="policy-card">
//         <Card.Body>
//           <div className="policy-header-container">
//             <h3 className="policy-header">Cancellation Policy & Payment Terms</h3>
//             <p className="policy-subheader">We keep it transparent, crystal clear!</p>
//           </div>
          
//           <div className="table-responsive">
//             <Table responsive striped bordered hover className="cancellation-table">
//               <thead>
//                 <tr>
//                   <th className="primary-header">Cancellation received no. of days prior to departure</th>
//                   <th>0 to 5</th>
//                   <th>6 to 15</th>
//                   <th>16 to 30</th>
//                   <th>31 to 45</th>
//                   <th>46 to 60</th>
//                   <th>61 to 90</th>
//                   <th>91 to 120</th>
//                   <th>121 to 900</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td className="primary-header">Cancellation fee applicable on Net Tour Price (per person)</td>
//                   <td data-label="0 to 5" className="percentage-high">100%</td>
//                   <td data-label="6 to 15" className="percentage-high">75%</td>
//                   <td data-label="16 to 30" className="percentage-medium">50%</td>
//                   <td data-label="31 to 45" className="percentage-medium">40%</td>
//                   <td data-label="46 to 60" className="percentage-medium">30%</td>
//                   <td data-label="61 to 90" className="percentage-low">20%</td>
//                   <td data-label="91 to 120" className="percentage-low">15%</td>
//                   <td data-label="121 to 900" className="percentage-low">10%</td>
//                 </tr>
//               </tbody>
//             </Table>
//           </div>
          
//           <Row className="mt-4">
//             <Col>
//               <div className="payment-terms-section">
//                 <h4 className="section-title">Payment Terms</h4>
//                 <p>
//                   Guest can pay by Cheque/ Demand Draft/ Debit card / Credit card/ NEFT/ RTGS/ IMPS. 
//                   For Debit / Credit card payment additional 1.8% convenience charge will be applicable. 
//                   Cheque / Demand draft should be in favour of "Radhe Shyam Pvt Ltd"
//                 </p>
//               </div>
//             </Col>
//           </Row>
          
//           <Row className="mt-4">
//             <Col>
//               <div className="remarks-section">
//                 <h4 className="section-title">Remarks</h4>
//                 <ul className="remarks-list">
//                   <li>
//                     All meals are provided by Radhe Shyam World in case the flight reaches the stipulated destination
//                     early morning or leaves destination late in the evening.
//                   </li>
//                   <li>The tour price mentioned for this tour is for Indian nationals only.</li>
//                   <li>
//                     The tour price varies for NRI's or foreign nationals, for more details kindly contact your travel
//                     advisor.
//                   </li>
//                   <li>
//                     NRIs and Foreign nationals please ensure proper identity is conveyed to booking executive at the
//                     time of booking and all details along with passport copies are handed over to the booking executive.
//                   </li>
//                   <li>
//                     Standard Check-in and check-out time of hotels in India is generally 1.30 PM and 10 AM respectively.
//                   </li>
//                 </ul>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// };

// export default CancellationPolicy;
import React from 'react';
import { Container, Row, Col, Table, Card } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import './../../assets/css/CancellationPolicy.css';

const CancellationPolicy = ({ webSettings }) => {
  if (!webSettings) return null;

  const policies = webSettings.cancellationPolicy || [];
  const toursRemarksHTML = webSettings.web_tours_remarks || "";

  // Simple helper to extract <li> from HTML string
  const parseListItems = (htmlString) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const listItems = Array.from(tempDiv.querySelectorAll('li'));
    return listItems.map((li, idx) => (
      <li key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
        <FaCheckCircle style={{ color: '#0a3b78', marginRight: '6px' }} />
        {li.textContent}
      </li>
    ));
  };

  // Extract other non-list content
  const parseOtherContent = (htmlString) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const content = Array.from(tempDiv.childNodes).filter(
      node => node.nodeName !== 'li'
    );
    return content.map((node, idx) => {
      if (node.nodeName === '#text') return <div key={idx} style={{
        background:"red"
      }}>   
      <FaCheckCircle style={{ color: '#0a3b78', marginRight: '6px' }} />      
  {node.textContent}</div>;
      return <div key={idx} dangerouslySetInnerHTML={{ __html: node.outerHTML }}  />;
    });
  };

  return (
    <Container className="cancellation-policy-section">
      <Card className="policy-card">
        <Card.Body>
          <div className="policy-header-container">
            <h3 className="policy-header">Cancellation Policy & Payment Terms</h3>
            <p className="policy-subheader">We keep it transparent, crystal clear!</p>
          </div>

          {/* ===== CANCELLATION TABLE ===== */}
          <div className="table-responsive">
            <Table responsive striped bordered hover className="cancellation-table">
              <thead>
                <tr>
                  <th className="primary-header">Cancellation received no. of days prior to departure</th>
                  {policies.map((p, i) => (
                    <th key={i}>{p.prior_of_day}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="primary-header">Cancellation fee applicable on Net Tour Price (per person)</td>
                  {policies.map((p, i) => {
                    let percentageClass = '';
                    const percent = parseInt(p.refundable);
                    if (percent >= 75) percentageClass = 'percentage-high';
                    else if (percent >= 40) percentageClass = 'percentage-medium';
                    else percentageClass = 'percentage-low';

                    return (
                      <td key={i} data-label={p.prior_of_day} className={percentageClass}>
                        {p.refundable}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </Table>
          </div>

          {/* ===== REMARKS & PAYMENT TERMS ===== */}
          {toursRemarksHTML && (
            <Row className="mt-4">
              <Col>
                <div className="remarks-section">
                  {parseOtherContent(toursRemarksHTML)}
                  {/* <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                    {parseListItems(toursRemarksHTML)}
                  </ul> */}
                </div>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CancellationPolicy;
